export default "__VITE_ASSET__DpWMxxqQ__"